import { Link } from "@fluentui/react";
import "./index.css";
import { CustomModal } from "../../components/custom-modal";
import { APP_SETTINGS } from "../../config/config";

interface INoPermissionProps {
  isModalOpen: boolean;
  onCancelClick: () => void;
}

const renderContent = () => {
  return (
    <h3>
      You do not have the necessary permissions to view the data in this portal.
      To request read/write access, please follow these instructions : {" "}
      <Link
        className="Lab-inventory-lease-action-link"
        href={APP_SETTINGS.REQUEST_PERMISSION_LINK}
        rel="noopener noreferrer" target="_blank"
      >
        How to Request Lab Portal Permissions
      </Link>
    </h3>
  );
};

const NoPermission = (props: INoPermissionProps) => {
  const { isModalOpen, onCancelClick } = props;
  return (
    <CustomModal
      title={"Permissions Required"}
      subTitle=""
      isModalOpen={isModalOpen}
      onDismiss={onCancelClick}
      content={renderContent()}
      minHeight={100}
      minWidth={250}
    ></CustomModal>
  );
};

export default NoPermission;
